import React, { useState, useCallback } from 'react';
import Sidebar from './Sidebar';
import { useMediaQuery } from '../hooks/useMediaQuery';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const toggleSidebar = useCallback(() => setSidebarOpen(prev => !prev), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div style={{ ...styles.container, flexDirection: isMobile ? 'column' : 'row' }}>
      {isMobile && (
        <header style={styles.mobileHeader}>
          <img src="/logo.png" alt="Unio AI Logo" style={styles.mobileLogo} />
        </header>
      )}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <main style={{ ...styles.main, marginLeft: isMobile ? 0 : 'var(--sidebar-width)' }}>
        <div style={{ ...styles.mainInner, paddingBottom: isMobile ? '90px' : '1.5rem' }}>
          {children}
        </div>
      </main>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    background: 'var(--bg-page)',
    fontFamily: 'var(--font-body)',
  },
  main: {
    flex: 1,
    marginLeft: 'var(--sidebar-width)',
    minHeight: '100vh',
    transition: 'margin-left 0.3s ease',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden'
  },
  mainInner: {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    padding: '1.5rem',
    boxSizing: 'border-box',
    overflowX: 'hidden'
  },
  mobileHeader: {
    height: '60px',
    background: 'var(--bg-sidebar)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    position: 'sticky',
    top: 0,
    zIndex: 99,
    width: '100%',
  },
  mobileLogo: {
    height: '38px',
    width: 'auto',
    objectFit: 'contain',
  },
};

export default Layout;

